export default __webpack_public_path__ + "transfix-maps/icons/P1-newWave.3c88edc86f1699fd5daa48bc3798110b.png";